import { Modal } from 'ant-design-vue'
import axios from 'axios'
import { TOKEN } from '../constants'
import { getSession, removeSession, setSession } from './session'

const noTokenApi = ['/xindlCustomer/save', '/xindlCustomer/getWarrantyCards', '/oss/token', '/sys/region/listTree', '/xindlCustomer/driving/license']
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API
})
service.postForm = function (url, data, opt) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    const value = data[key]
    if (typeof value === 'object') {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, data[key])
    }
  })
  return service.post(url, formData, opt)
}

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getSession(TOKEN)
    if (token && !noTokenApi.some(x => config.url.indexOf(x) >= 0)) config.headers['Authorization'] = token
    if (document.getElementsByClassName('modal-login-timeout').length) {
      config.cancelToken = new axios.CancelToken(cancel => {
        cancel()
      })
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // 请求二进制数据时，不对返回值做处理
    if (response.request.responseType === 'blob') {
      return response
    }
    const res = response.data
    const token = response.headers['authorization']
    if (token) {
      setSession(TOKEN, token)
    }
    if (res.code !== '00000') {
      // 登录验证
      if (res.code === 'A0230') {
        if (!document.getElementsByClassName('modal-login-timeout').length) {
          Modal.confirm({
            title: '登录超时，请重新登录',
            okText: '重新登录',
            class: 'modal-login-timeout',
            keyboard: false,
            onOk () {
              removeSession(TOKEN)
              location.reload()
            }
          })
        }
        return {
          code: '00000',
          data: {}
        }
      } else {
        console.error(`You see this message because the code of the response is not '00000'(actually ${res.code}), please read the msg and check:\n${res.msg}`)
        return { ...response.data, $response: response }
      }
    } else {
      return { ...response.data, $response: response }
    }
  },
  error => {
    console.log('request error：', error)
    if (axios.isCancel(error)) {
      console.log('request cancel')
    } else {
      let { response } = error
      return response ? { ...response.data, $response: response } : Promise.reject(error)
    }
  }
)

export { service }
